import React, { useState } from "react";
import PropTypes from "prop-types";
import "../AddChecklistModal/AddChecklistModal.scss";

export default function AddChecklistModal({ open, onClose, toDoId, onCreateTodoList }) {
  const [title, setTitle] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const canSubmit = title.trim().length > 0 && toDoId;

  const handleCreate = async () => {
    if (!canSubmit) return;
    setSubmitting(true);
    try {
      await onCreateTodoList?.({
        toDoListTitle: title.trim(),
        completion: false,
        toDoId: Number(toDoId),
      });
      onClose?.();
    } catch (e) {
      console.error("[AddChecklistModal] create failed:", e);
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <div className="cp-modal-addchecklist-overlay">
      <div className="cp-modal-addchecklist">
        <div className="cp-modal-addchecklist-header">
          <h3>Add Checklist Item</h3>
          <button onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="cp-modal-addchecklist-body">
          <label>
            <span>Title </span>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter item title"
              autoFocus
            />
          </label>
        </div>

        <div className="cp-modal-addchecklist-footer">
          <button onClick={onClose} className="btn-ghost">Cancel</button>
          <button
            disabled={!canSubmit || submitting}
            onClick={handleCreate}
            className="btn-primary"
          >
            {submitting ? "Adding…" : "Add"}
          </button>
        </div>
      </div>
    </div>
  );
}

AddChecklistModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  toDoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onCreateTodoList: PropTypes.func,
};
